export default {
    getUsuariosListado(state, getters, rootState) {
        return [{ nombre: 'Sin User', id: null }, ...state.usuarios.filter(u => u.roles.includes(rootState.modoFuncionamiento))]
    }
}